import _ from 'lodash';
import BrowserStorageAccessor from '../utils/BrowserStorageAccessor';
import axios from '../requester';
import { API } from '../constants/api-urls';
import { getContributorAvatarUrl } from 'common/constants/Avatars';
import { SENSOR_TYPES, SESSION_STORAGE_KEYS } from '../constants/constants';
import debounce from 'lodash/debounce';

export const getContributors = debounce(
  async (params = {}) => {
    // params.reduce_content = true;
    return axios.get(API.CONTRIBUTORS_PATH, {
      params: { ...params, sensor_type_id: SENSOR_TYPES.GIT }
    });
  },
  10000,
  { leading: true, trailing: false }
);
export const matchContributorMetricsToContributor = (contributors, metrics) => {
  const contributorById = _.keyBy(contributors, 'id');

  return metrics
    .filter(({ contributor_id }) => !!contributorById[contributor_id])
    .map(metric => {
      const { contributor_id } = metric;
      const contributor = contributorById[contributor_id] || {};
      const { name, username, email, extended_data, is_parent, contained_ids } =
        contributor;

      return {
        providerId: _.get(extended_data, 'provider_id', null),
        avatarUrl: getContributorAvatarUrl(contributor),
        name,
        username,
        email,
        is_parent,
        contained_ids,
        ...metric
      };
    });
};

export const getContributorsDefaultView = () =>
  BrowserStorageAccessor().session.get(
    SESSION_STORAGE_KEYS.CONTRIBUTORS_DEFAULT_VIEW
  ) || 'teams';

export const setContributorsDefaultView = view =>
  BrowserStorageAccessor().session.set(
    SESSION_STORAGE_KEYS.CONTRIBUTORS_DEFAULT_VIEW,
    view
  );

export const connectContributors = body =>
  axios.patch(`${API.CONTRIBUTORS_PATH}/connect`, body);

export const deleteFromAllTeams = async id =>
  axios.delete(`${API.CONTRIBUTORS_PATH}/remove-from-all-teams/${id}`);
